import React, { useEffect, useState } from 'react'
import { ManageInnerCategory } from '../Menu/Logic'
import ModalFilterComponent from '../PromoCode/Component/ModalFilterComponent'
import axios from "axios";
import FilterComponent from "../../CoreComponents/FilterComponent";
import { protocol, url } from "../../Functionalities/Config";
import {
    ManageProducts,
    showMessage,
    getToken,
    ManageRestaurant,
} from "../../Functionalities/Functions";
function InnerCategory(props) {

    // void 0
    // const [existingTag, setexistingTag] = useState();
    const [catData, setCatData] = useState([]);
    const [tagList, settagList] = useState([])
    const [search, setSearch] = useState('')
    const [next, setNext] = useState("");
    const [prev, setPrev] = useState("");
    const [catName, setcatName] = useState([])
    // const [errors, setErrors] = useState([])
    // useEffect(() => {
    //     if (errors.length > 0) {
    //         showMessage(errors[0], "danger", "Following fields required!", "top", "top-right", 0)
    //     }
    // }, [errors])
    useEffect(() => {
        let existingTag = []
        props.existingTag && props.existingTag.map(ex => {
            existingTag.push(ex.id)
        })
        settagList(existingTag)
        props.customerFunction(existingTag)
    }, [props.existingTag])

    useEffect(() => {
        setcatName(props.existingTag)
    }, [props.existingTag])

    useEffect(() => {

        getCategoryData();
    }, [search, tagList]);
    // void 0
    // void 0

    const getCategoryData = async () => {
        if (tagList.length != 0) {
            let params = `exclude_categories=${JSON.stringify(tagList)}&for_dropdown=true&page_wise=true&search_text=${search}`;
            let result = await ManageInnerCategory("", "", "get", params);

            const list = Array.isArray(result?.data?.results)
              ? result.data.results
              : (Array.isArray(result?.data)
                  ? result.data
                  : (Array.isArray(result?.data?.data) ? result.data.data : []));
            setCatData(list);
            setNext(result?.data?.next || "");
            setPrev(result?.data?.previous || "");
        }
        else {
            let params = `for_dropdown=true&page_wise=true&search_text=${search}`;
            let result = await ManageInnerCategory("", "", "get", params);
            const list = Array.isArray(result?.data?.results)
              ? result.data.results
              : (Array.isArray(result?.data)
                  ? result.data
                  : (Array.isArray(result?.data?.data) ? result.data.data : []));
            setCatData(list);
            setNext(result?.data?.next || "");
            setPrev(result?.data?.previous || "");
        }
    }
    const handlePrev = () => {
        // alert("prev");

        var config = {
            method: "get",
            url: prev.replace("http:", protocol.replace('//', "")),
            // url: prev + "/?" + params,

            headers: {
                Authorization: getToken(),
            },
        };
        // void 0
        axios(config)
            .then(function (response) {
                const list = Array.isArray(response?.data?.results)
                  ? response.data.results
                  : (Array.isArray(response?.data)
                      ? response.data
                      : (Array.isArray(response?.data?.data) ? response.data.data : []));
                setCatData(list);
                setNext(response?.data?.next || "");
                setPrev(response?.data?.previous || "");
            })
            .catch(function (error) {
                // void 0
            });
    };

    const handleNext = () => {
        // alert("next")
        var config = {
            method: "get",
            url: next.replace("http:", protocol.replace('//', "")),
            // url: next + "/?" + params,

            headers: {
                Authorization: getToken(),
            },
        };
        axios(config)
            .then(function (response) {
                const list = Array.isArray(response?.data?.results)
                  ? response.data.results
                  : (Array.isArray(response?.data)
                      ? response.data
                      : (Array.isArray(response?.data?.data) ? response.data.data : []));
                setCatData(list);
                setNext(response?.data?.next || "");
                setPrev(response?.data?.previous || "");
            })
            .catch(function (error) {
                // void 0
            });
    };

    function Push(id, name) {
        if (!tagList.includes(id)) {
            settagList(prev => [...prev, id])
            setcatName(prev => [...prev, { id: id, name: name }])
            var x = prev => [...prev, id]
            var y = prev => [...prev, { id: id, name: name }]
            showMessage("Menu added", "success", "Success!", "top", "top-right", 0)
            props.customerFunction(x)
            props.nameFunction(y)
        }
    }
   
    return (
        <div>

            <div className="modal fade" id="userSelectModal">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <ModalFilterComponent searchFunction={(data) => {
                            setSearch(data)
                        }} />

                        {/* <div className="modal-header">
                            {<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', marginBottom: 10 }}>
                                <button disabled={prev == null ? true : false} onClick={(e) => {e.preventDefault();handlePrev()}}
                                    style={{ cursor: !prev ? 'default' : "pointer", backgroundColor: !prev ? 'gray' : "#3fb049", color: 'white', border: 'none', paddingLeft: 10, paddingRight: 10, borderRadius: 8 }}>
                                    prev</button>
                                <button disabled={next == null ? true : false}
                                    onClick={(e) => {e.preventDefault();handleNext()}}
                                    style={{ cursor: !next ? 'default' : "pointer", backgroundColor: !next ? 'gray' : "#3fb049", color: 'white', border: 'none', paddingLeft: 10, paddingRight: 10, borderRadius: 8 }}>
                                    next</button>
                            </div>}
                            <button type="button" className="close" data-dismiss="modal"><span>×</span>
                            </button>
                        </div> */}
                        <div className="modal-body">
                            <div className="table-responsive rounded card-table">
                                <table className="table items-table table-responsive-sm">
                                    <tbody>
                                        <tr>
                                            <th className="my-0 text-black font-w500 fs-3">Menu</th>
                                            <th className="my-0 text-black font-w500 fs-3">Select</th>
                                        </tr>
                                        {(Array.isArray(catData) ? catData : []).length > 0 &&
                                            (Array.isArray(catData) ? catData : []).map((item, index) => {
                                                return (
                                                    <tr className="alert alert-dismissible border-0">
                                                        <td>
                                                            <div className="media">
                                                                <div className="media-body">
                                                                    <small className="font-w500">
                                                                        <a className="text-primary" href="javascript:void(0);">
                                                                            {item.id} :{item.name}
                                                                        </a>
                                                                    </small>

                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <h4 className="my-0 text-black font-w600">
                                                                <div><span onClick={(e) => {
                                                                            e.preventDefault()
                                                                            Push(item.id, item.name)
                                                                        }
                                                                    }
                                                                    style={{ fontSize: 25, cursor: 'pointer' }}>+</span>
                                                                </div>
                                                            </h4>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        }

                                    </tbody>
                                </table>
                            </div>
                        </div>


                        <div className="modal-footer">
                            {/* <button type="button" className="btn btn-danger light" data-dismiss="modal"
                                onClick={
                                    (e) => {
                                        e.preventDefault()

                                    }
                                }
                            >Close</button> */}
                            <button type="button" className="btn btn-primary" data-dismiss="modal"
                                onClick={
                                    (e) => {
                                        e.preventDefault()
                                        props.customerFunction(tagList)
                                        props.nameFunction(catName)
                                    }
                                }
                            >OK</button>

                        </div>
                    </div>
                </div>
            </div>


        </div>

    )
}

export default InnerCategory
